export function genTestUserSig2(userID) {//usersig  服务端加密
  const SDKAPPID = 1400765956 //线上
//   const SDKAPPID = 1400789171
//   const SECRETKEY = '9c23e0cacf5473ccfadf21e5b35e962a5448742c7a0f226eef27f8b56eb6de4e'
//   var TLSSigAPIv2 = require('./TLSSigAPIv2');
//   var api = new TLSSigAPIv2.Api(SDKAPPID, SECRETKEY);
//   var sig = api.genUserSig(userID, 86400 * 180);
 return {
    sdkAppID: SDKAPPID,
    // userSig: sig,
  }
}